/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pilates_TermsInputs */

const en_service_type_pilates_terms = /** @type {(inputs: Service_Type_Pilates_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pilates, mat pilates`)
};

const pl_service_type_pilates_terms = /** @type {(inputs: Service_Type_Pilates_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pilates, pilates na macie, mata`)
};

/**
* | output |
* | --- |
* | "pilates, mat pilates" |
*
* @param {Service_Type_Pilates_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pilates_terms = /** @type {((inputs?: Service_Type_Pilates_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pilates_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pilates_terms(inputs)
	return en_service_type_pilates_terms(inputs)
});